export default __webpack_public_path__ + "static/pas-2cb906a0195e66c7e6d5e3b25593329f.png";